import React from 'react';
import { Navigate, Route, Routes, useParams, useLocation } from "react-router-dom";
import {Container, Row} from 'react-bootstrap';
import Header from './components/Header';
import LeftNav from './components/LeftNav';
import {useSelector} from 'react-redux';
import {getDefaultAccountKey} from './app/slices/UserSlice';
import Footer from './components/Footer'
import NotFound from './components/NotFound';

import Support from './routes/contact/Support';
import Profile from './routes/profile/Profile';
import Dashboard from './routes/dashboard/Dashboard';
import Applications from './routes/applications/Apps';
import Account from './routes/account/Account';
import Analytics from './routes/analytics/Analytics';
import Guardrails from './routes/guardrails/Guardrails';
import Experiments from './routes/experiments/Experiments';

const AuthenticatedApp = () => {
  console.log('AuthenticatedApp: ' + (new Date()).toLocaleTimeString())
  //let match = useRouteMatch();
  let {accountKey} = useParams();

  const location = useLocation();
  const defaultAccountKey = useSelector(getDefaultAccountKey);

  return (
    <>
    {
      accountKey ? (
      <>
      <Header accountKey={accountKey}/>
      <Container fluid>
        <Row>
          {/*<LeftNav accountKey={accountKey}/>*/}
          <main className="col-md-10 ms-sm-auto col-lg-10 px-md-4 pt-md-4 mainApp">
            <Routes>
            <Route path='/apps/*' element={<Applications/>} />
              <Route path='/profile/*' element={<Profile/>} />
              <Route path='/account/*' element={<Account/>} />
              <Route path='/analytics/*' element={<Analytics/>}/>
              <Route path='/guardrails/*' element={<Guardrails/>}/>
              <Route path='/experiments/*' element={<Experiments/>}/>
              <Route path='/support' element={<Support/>}/>
              <Route path='/dashboard/:startFactDate?/:endFactDate?' element={<Dashboard/>}/>
              <Route path='/' element={<Dashboard/>}/>
            {/*  */} <Route path="*" element={<NotFound/>}  />
            </Routes>
            <Footer/>
          </main>

        </Row>

      </Container>
      </>
     ) :
      <Navigate to={{ pathname: "/account/" + defaultAccountKey, state: {from: location}}}/>
    }
    </>

  )
}

export default AuthenticatedApp;
